// src/pages/Workflows/hooks/useWorkflowsList.js

import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

export function useWorkflowsList() {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filtro, setFiltro] = useState('todos'); // 'todos' | 'meus' | 'partilhados'
  const [pesquisa, setPesquisa] = useState('');
  const [workflowParaEliminar, setWorkflowParaEliminar] = useState(null);
  const [eliminando, setEliminando] = useState(false);

  const carregar = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await axios.get('/api/workflows');
      if (response.data.success) {
        setWorkflows(response.data.data);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao carregar workflows');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const eliminar = useCallback(async (id) => {
    try {
      setEliminando(true);
      await axios.delete(`/api/workflows/${id}`);
      setWorkflows(prev => prev.filter(w => w.id !== id));
      setWorkflowParaEliminar(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao eliminar workflow');
    } finally {
      setEliminando(false);
    }
  }, []);

  // Filtragem e pesquisa aplicadas localmente
  const workflowsFiltrados = workflows.filter(w => {
    const userEmail = localStorage.getItem('userEmail') || '';

    if (filtro === 'meus' && w.user_email !== userEmail) return false;
    if (filtro === 'partilhados' && w.visibilidade !== 'shared') return false;

    if (pesquisa.trim()) {
      const q = pesquisa.toLowerCase();
      return (
        w.nome.toLowerCase().includes(q) ||
        (w.descricao || '').toLowerCase().includes(q)
      );
    }
    return true;
  });

  return {
    workflows: workflowsFiltrados,
    loading,
    error,
    filtro,
    setFiltro,
    pesquisa,
    setPesquisa,
    workflowParaEliminar,
    setWorkflowParaEliminar,
    eliminando,
    eliminar,
    carregar,
  };
}
